import React from 'react';
import PropTypes from 'prop-types';
import {StyledCard} from "../../styleHelper";
import {Card} from "../../styledComponents";
import Grid from 'styled-components-grid';
import ThxBox from './components/thxBox';
import Summary from './components/Summary';
import MyTable from "./components/table";
import ReservationInformation from "./components/ReservationInformation";
import CollectorCheckout from 'collector-checkout';
import Collector from './components/Collector';
import ReactGA from 'react-ga';


const address = process.env.REACT_APP_CONFIRMATION;

const DEFAULT_CONFIG = {
    trackingId: 'UA-30343656-2',
    debug: false
    //gaOptions: {
    //    cookieDomain: 'none'
   // }
};


class Confirmation extends React.Component {

    state = {
        data: [],
        isLoading: true,
        noBooking: false
    };

    componentDidMount() {
        const {match} = this.props;
        const bookingHash = match.params.id;
        const bookingId = 'rzvoyxarpoaw';

        let fetchData = address + bookingHash;


        fetch(fetchData)
            .then(response => response.json())
            .then(data => this.setState({data, isLoading: false}))
            .catch(e => this.setState({noBooking: true}));


    }

     checkAndSend() {
        if (!('parentIFrame' in window)) {
            console.log('No parentIFrame object yet...');
            setTimeout(this.checkAndSend, 16); // setTimeout(func, timeMS)
        } else {
            window.parentIFrame.sendMessage('scrollUp');
            console.log('found parentIFrame object! Sent message.');
            return false;
        }
    }

    initReactGA = (category, label, value, trackingId = undefined) => {

        let thisConfig = {...DEFAULT_CONFIG };
        if (trackingId) {
            thisConfig = {...DEFAULT_CONFIG, ...{trackingId}};
        }
        ReactGA.initialize(thisConfig);
        // Send initial test view
        //ReactGA.pageview('test-init-pageview');

        ReactGA.event({
            action: 'booking confirmed',
            category,
                label,
                value
        });
    };


    render() {
        this.checkAndSend();


        const {data, isLoading, noBooking} = this.state;
        const {match} = this.props;

        if (noBooking) {
            return (<div>No booking with that id!</div>);

        }

        if (isLoading) {
            return (<div>Laddar...</div>);
        }


        if (data.hasOwnProperty('ga')) {
            const nameOfField = Object.keys(data.bookingSummary.bookingItems)[0];
            const nameOfProduct = data.bookingSummary.bookingItems[nameOfField][0].name;
            const bookingItems = data.bookingSummary.bookingItems;
            const gaTotalCost = (Object.keys(bookingItems).map((key) =>
                bookingItems[key].map((product) => product.cost * product.qty))).reduce((prev, curr) => +prev + +curr, 0);


            this.initReactGA(nameOfProduct, nameOfField, gaTotalCost, data.ga.config);



        }




        //let test = data.greetings.details.match(/\[url='([^\]]+)'\]\s*(.*?)\s*\[\/url\]/i);

        //console.log('this', test);


        const gridSize = {mobile: 1, tablet: 1 / 2, desktop: 1 / 4};



        const bookingHash = match.params.id;



        return (
            <Grid
                ref={(divElement) => { this.divElement = divElement; }}
            >
                <Grid.Unit size={1}>
                    <ThxBox greetings={data.greetings}/>
                </Grid.Unit>
                <Grid.Unit size={{mobile: 1, desktop: 1 / 2}}>
                    <Card
                        title="Sammanfattning">
                        <dl>
                            <dt>
                                Datum
                            </dt>
                            <dd>
                                {data.bookingSummary.date}
                            </dd>
                        </dl>
                        <MyTable
                            data={data.bookingSummary.bookingItems}
                        />
                    </Card>

                </Grid.Unit>
                <Grid.Unit size={{mobile: 1, desktop: 1 / 2}}>
                    <ReservationInformation
                        customerInformation={data.customerInformation}/>
                </Grid.Unit>
                {data.hasOwnProperty('waiver') && (
                    <Grid.Unit size={1}>
                        <Card
                        title='Spelavtal'
                        >
                            <p>
                                Alla som ska spela ska fylla i ett spelavtal.
                                <a href={`https://bookat.io/signWaiver/${bookingHash}`} target='_blank'> Här hittar ni det!</a>
                            </p>
                            <h3>Följande deltagare har fyllt i avtalet:</h3>
                            <p>
                                {data.waiver.map((name) => <React.Fragment>{name}<br /></React.Fragment>)}
                            </p>
                        </Card>

                    </Grid.Unit>

                )}
                <Grid.Unit size={1}>
                    {data.hasOwnProperty('collector') && (
                        <Collector
                            tokens={data.collector}/>
                    )}

                </Grid.Unit>


            </Grid>
        )
    }
}

Confirmation.propTypes = {};

export default Confirmation;



// WEBPACK FOOTER //
// ./src/components/Confirmation/index.js